import { DffOprindeligAktuelVaerdi } from "@dffedb/util";

import { TaellevaerkAflaesning } from "./taellevaerk-aflaesning.model";

export class MaalerAflaesning {
    public maalerNr: DffOprindeligAktuelVaerdi<string>;
    public maalerTypeId: DffOprindeligAktuelVaerdi<number>;
    public taellevaerker: TaellevaerkAflaesning[];
}
